<section class="mx-3 py-0">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <div class="d-flex align-items-center">
      <button mat-icon-button class="back_icon me-2" (click)="backPage()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <div *ngIf="BatchData" class="page_header">
        <h4 class="m-0 page_header_title">
          {{ BatchData?.start_year | date : "yyyy" }} -
          {{ BatchData.end_year | date : "yyyy" }} Academics
        </h4>
      </div>
    </div>
  </div>

  <div class="semester_details_card">
    <div class="bg-white card p-4">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="Working Hours">
          <div class="">
            <div class="text-end mt-2">
              <button
                mat-flat-button
                color="primary"
                class="add_button"
                (click)="openShiftDialog()"
              >
                <i class="fa-solid fa-plus"></i> <span translate>Add Shift</span>
              </button>
            </div>
            <div *ngIf="academic_year_id"><app-shift [item]="academic_year_id"></app-shift></div>
          </div>
        </mat-tab>
        <mat-tab label="Week Off">
          <div class="">
            <div class="text-end mt-2">
              <button
                mat-flat-button
                color="primary"
                (click)="openweekoffDialog()"
                class="add_button"
              >
                <i class="fa-solid fa-plus"></i> <span translat>Add Week Off</span>
              </button>
            </div>
            <div><app-weekoff [item]="BatchData"></app-weekoff></div>
          </div>
        </mat-tab>
        <mat-tab label="Holidays">
          <div class="">
            <div class="text-end mt-2">
              <button
                mat-flat-button
                color="primary"
                (click)="openholidayDialog()"
              >
                <i class="fa-solid fa-plus"></i> <span translate>Add Holiday</span>
              </button>
            </div>
            <div><app-holidays [item]="academic_year_id"></app-holidays></div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</section>
